import React from 'react';

const VARIANT_CLASS = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  action: 'btn-action',
  view: 'btn-action btn-view',
  edit: 'btn-action btn-edit',
  activate: 'btn-action btn-activate',
  deactivate: 'btn-action btn-deactivate',
  danger: 'btn-action btn-danger',
  'danger-solid': 'btn-danger',
};

function Button({
  variant = 'primary',
  size,
  icon: Icon,
  loading = false,
  disabled = false,
  as: Component = 'button',
  className = '',
  children,
  ...rest
}) {
  const variantClass = VARIANT_CLASS[variant] || VARIANT_CLASS.primary;
  const sizeClass = size === 'sm' ? 'btn-sm' : '';

  return (
    <Component
      className={[variantClass, sizeClass, className].filter(Boolean).join(' ')}
      disabled={Component === 'button' ? disabled || loading : undefined}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? (
        <span className="btn-spinner" aria-hidden="true" />
      ) : (
        Icon && <Icon size={16} style={{ marginRight: children ? 6 : 0 }} />
      )}
      {children}
    </Component>
  );
}

export default Button;
